import { render, staticRenderFns } from "./pointVolunteerList.vue?vue&type=template&id=c0c2eae4&scoped=true"
import script from "./pointVolunteerList.vue?vue&type=script&lang=js"
export * from "./pointVolunteerList.vue?vue&type=script&lang=js"
import style0 from "./pointVolunteerList.vue?vue&type=style&index=0&id=c0c2eae4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0c2eae4",
  null
  
)

export default component.exports